import { Modal, Text } from "@mantine/core";
import { Button } from "src/components/shared/Button/Button";
import { Flex } from "src/styled";
interface Props {
  onYes: () => void;
  isOpen: boolean;
  onClose: () => void;
  audit?: boolean;
}
const CompletePopup = ({ onYes, isOpen, onClose, audit }: Props) => {
  const handleYes = () => {
    onClose();
    onYes();
  };
  return (
    <Modal onClose={onClose} opened={isOpen}>
      <Text fw={200} ta="center">
        All entries have been verified!
      </Text>
      <Text ta="center">
        Do you want to complete the {audit ? "audit" : "review"}?
      </Text>
      <Flex justify="space-between" mt={10}>
        <Button onClick={onClose} color="red">
          No
        </Button>
        <Button onClick={handleYes}>Yes</Button>
      </Flex>
    </Modal>
  );
};
export default CompletePopup;
